<script setup lang="ts">
import { Heading } from "~/components/clarity-ui/Heading";
import { Checkbox } from "~/components/clarity-ui/Checkbox";
import { contentToTailwindClasses } from "~/utils/helper/tailwind";

defineProps({
  content: Object,
  modelValue: Boolean,
});

const internalValue = defineModel<boolean>("modelValue");
</script>

<template>
  <div
    v-if="content.newsletterActive"
    class="text-start"
    :class="[
      (content?.backgroundColor && content?.backgroundColor !== 'none') || content?.borderActive
        ? 'rounded-2xl p-6'
        : 'p-0',
      { 'border border-base-03': content?.borderActive },
      contentToTailwindClasses({ backgroundColor: content?.backgroundColor }),
    ]"
  >
    <Heading size="small" tag="h3" class="mb-4">
      {{ content.newsletterHeadline }}
    </Heading>
    <Checkbox v-model="internalValue">
      <div class="prose text-sm" v-html="content?.marketingConsentText" />
    </Checkbox>
  </div>
</template>
